import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

const MSICCodeSelect = ({ name, label = 'MSIC Code', control, errors, readOnly = false }) => {
  const msicCodes = useSelector((state) => state.msicCodes.msicCodes);
  const msicCodeOptions = msicCodes.map((item) => {
    return { key: item.Code, value: item.Description };
  });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <Autocomplete
            {...field}
            id={name}
            options={msicCodeOptions}
            readOnly={readOnly}
            getOptionLabel={(option) => `${option.key} - ${option.value}`}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                error={!!get(errors, name, null)}
                helperText={get(errors, name, {})?.message}
              />
            )}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            onChange={(_, value) => field.onChange(value)}
            value={field.value || null} // handle default value
          />
        );
      }}
    />
  );
};

export default MSICCodeSelect;
